var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-form"},[_c('div',{staticClass:"card-element",attrs:{"id":'card-element-' + _vm._uid}}),_vm._v(" "),_c('div',{staticClass:"card-errors",attrs:{"id":'card-errors-' + _vm._uid,"role":"alert"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }